<script lang="ts">
    import PanelistSurveyDashboardPage from '@Evaluation/CriteriaSurveys/Pages/PanelistSurveyDashboardPage'
    export default PanelistSurveyDashboardPage
</script>

<template>
    <div>
        <CriterionDetailsDialog :viewModel="criterionDetailsDialog" />

        <WeightsViewerDialog :propOpened="weightsViewerOpened === true" :propRm="weightsViewer"
                             @export-panelist-weights="handleExportWeightsToXlsFromPanelistVotesCommand"
                             @close-dialog="weightsViewerOpened = false" />

        <PanelistConsistencyAnalysisDialog :propOpened="panelistConsistencyAnalysisOpened === true" :propRm="panelistConsistencyAnalysis"
                                           @close-dialog="panelistConsistencyAnalysisOpened = false" />

        <template v-if="viewTemplate === 'default'">
            <nav class="navbar navbar-expand-md navbar-dark bg-dark">
                <div class="container">
                    <form class="form-inline my-2 my-lg-0 ml-auto">
                        <a class="btn btn-light mr-2" v-sanitizedHref="rm.MeetingUrl">Join Meeting</a>

                        <div class="btn-group mr-2" role="group">
                            <button type="button" class="btn btn-light dropdown-toggle" data-toggle="dropdown">
                                My votes
                            </button>
                            <div class="dropdown-menu">
                                <a class="dropdown-item" @click="showRespondentConsistencyAnalysis">Check consistency</a>
                                <a class="dropdown-item" @click="showWeightsViewer">View weights</a>
                                <a class="dropdown-item" @click="handleExportPanelistVotesToXlsCommand">Download to xls</a>
                            </div>
                        </div>

                        <a class="btn btn-light" href="https://www.transparentchoice.com/user-guide/respondents-weights" title="Respondents guide: Criteria Weights" target="_blank">
                            <i class="fa fa-info" aria-hidden="true"></i>
                        </a>
                    </form>
                </div>
            </nav>

            <div class="container">
                <h3 class="mt-5 font-weight-light">Survey: {{rm.SurveyName}}</h3>
                <p>Weight {{rm.CriteriaCount}} criteria grouped into {{rm.Contexts.length}} contexts by making {{rm.SurveyQuestionsCount}} pairwise comparisons.</p>
                <p class="lead">{{rm.SurveyDescription}}</p>
                <br />
                <table class="table table-hover mt-3">
                    <thead>
                        <tr>
                            <th>Context</th>
                            <th><a class="pointer" @click="orderByProgressAsc = !orderByProgressAsc">Progress</a></th>
                            <th style="width: 120px;"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="c in criteriaView" :key="c.Id">
                            <td>
                                <a class="text-dark" @click="showCriterionDetails(c)">{{c.Name}}</a><br />
                                <small>{{c.Path}}</small>
                            </td>
                            <td class="text-center">
                                <div class="progress" style="height: 30px;">
                                    <div class="progress-bar" role="progressbar" :style="{ width: c.Progress + '%' }" :title="c.Progress"></div>
                                </div>
                            </td>
                            <td class="text-center">
                                <a class="btn btn-outline-primary" v-sanitizedHref="c.EvaluationUrl">Weight</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>

        <template v-if="viewTemplate === 'loading'">
            <div class="container">
                <h3 class="text-center"><i class="fa fa-spinner fa-spin"></i> Loading...</h3>
            </div>
        </template>

        <template v-if="viewTemplate === 'closed'">
            <div class="d-flex justify-content-center" style="padding-top: 200px;">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">Survey is closed</h5>
                        <p class="card-text lead">Please wait for the host to open this survey or go to the meeting.</p><br />
                        <a class="btn btn-secondary" v-sanitizedHref="rm.MeetingUrl">Go to the meeting</a>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="viewTemplate === 'empty'">
            <div class="d-flex justify-content-center" style="padding-top: 200px;">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">Empty survey: {{rm.SurveyName}}</h5>
                        <p class="card-text lead">Sorry. This survey has no questions. Please contact the person who asked you to complete the survey for advice.</p>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
